import { Config, DomainsConfig } from './index';
import { getLocaleDomainDetails } from '@crazygames/countries/url-utils';
import { AVAILABLE_LOCALES } from '@crazygames/countries/locales';

//Cast, because we will add every locale right afterwards
const domains: DomainsConfig = {} as DomainsConfig;
AVAILABLE_LOCALES.forEach((locale) => {
  domains[locale] = getLocaleDomainDetails(locale, 'prod');
});

const config: Config = {
  graph: 'https://graph.crazygames.com',
  ga4ID: 'G-7YCCNTJ3D9',
  firebase: {
    apiKey: 'AIzaSyAcnWHv0-RhlmU5ONOXzOSP0Q6ORQEMrNg',
    authDomain: 'crazygames-prod.firebaseapp.com',
    databaseURL: 'https://crazygames-prod.firebaseio.com',
    projectId: 'crazygames-prod',
    storageBucket: 'crazygames-prod.appspot.com',
    messagingSenderId: '487034968410',
  },
  sentry: {
    dsn: 'https://2beef08402894169a6dcee68036eccf4@sentry.io/1284892',
    disabled: true,
  },
  aws: {
    filesDomain: 'files.crazygames.com',
    videoCdnPrefix: 'https://videos.crazygames.com',
    imagesCdnPrefix: 'https://imgs.crazygames.com',
  },
  domains: domains,
  kidSiteDomain: {
    base: 'https://kids.crazygames.com',
  },
};

export default config;
